/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestResultDto } from '../../models/contents-request-result-dto';

export interface ContentsRequestResultControllerFindById$Params {
  id: string;
}

export function contentsRequestResultControllerFindById(http: HttpClient, rootUrl: string, params: ContentsRequestResultControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestResultDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestResultControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestResultDto>;
    })
  );
}

contentsRequestResultControllerFindById.PATH = '/api/contents-request-result/{id}';
